import { string, object, func, bool } from 'prop-types'
import { Asset, Conditional, kuiperClassNames } from '@opallabs/kuiper'
import { ContentTextInput } from '../../../../ContentTextInput'
import { styles } from './styles.js'

export const SMSPreview = ({
  asset,
  content,
  isPresenting,
  onContentChange,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
}) => (
  <div style={styles.smsPreviewWrapper}>
    <Conditional condition={asset}>
      <div style={styles.smsImage}>
        <Asset
          imageFit="cover"
          hasAssetOverlay={Boolean(asset) && (!readOnly || isPresenting)}
          assetReference={asset}
          placeholder={true}
          removeable={!isPresenting}
          onEmbiggen={() => onExpandAsset(asset.id)}
          onRemove={() => onRemoveAsset(asset.id)}
          overrideStyles={{
            asset: styles.smsImageBase,
            assetBase: styles.smsImageBase,
          }}
        />
      </div>
    </Conditional>
    <div className={kuiperClassNames('sms-preview-text')}>
      <ContentTextInput
        characterLimit={160}
        placeholder="Add Text..."
        isSoftLimit={true}
        value={content}
        readOnly={readOnly}
        highlightSocialTags={true}
        characterCounterOptions={{ position: 'left', offset: 48 }}
        style={styles.getSmsPreview(Boolean(asset))}
        onChange={onContentChange}
      />
      <div style={styles.smsPreviewArrow} />
    </div>
  </div>
)

SMSPreview.propTypes = {
  asset: object,
  content: string,
  isPresenting: bool,
  onContentChange: func,
  onExpandAsset: func,
  onRemoveAsset: func,
  readOnly: bool,
}
